<template>
    <div class="history">
        <!-- 搜索组件 -->
        <page-search :search-config="searchConfig(searchOptions)" @query-click="handleQueryClick" ref="searchRef"
            @reset-click="handleResetClick" @export-click="hanldeExportExcel"
            :isShowExport="isShowExport"></page-search>
        <pageBoard :summary-data="summaryData" :show-handling-fee="show_handling_fee"></pageBoard>

        <el-card shadow="never" style="margin-top: 10px;">
            <!-- 内容组件，传递 orderList 数据 -->
            <page-content :order-list="orderList" :isloading="isloading" @show-detail="handleShowDetail"
                :show-handling-fee="show_handling_fee"></page-content>
            <!-- 分页组件 -->
            <div class="pagination">
                <el-pagination background layout="total, prev, pager, next" :total="total" :page-size="pageSize"
                    :current-page="currentPage" @current-change="handlePageChange" @size-change="handleSizeChange" />
            </div>
        </el-card>

        <!-- 订单详情弹出框 -->
        <page-modal ref="orderModal" :show-handling-fee="show_handling_fee" />
    </div>
</template>

<script setup>
import { ref, getCurrentInstance, onMounted } from "vue";
import pageSearch from '@/components/pageSearch/pageSearch.vue';
import pageContent from "./c-cpns/page-content.vue";
import pageBoard from "./c-cpns/page-board.vue";
import pageModal from "./c-cpns/page-modal.vue";
import searchConfig from './config/search.config';
import { ElMessage } from 'element-plus';
import { newTimeFormat } from '@/tools/time'

const { proxy } = getCurrentInstance();


// 订单列表数据
const orderList = ref([]);

const isloading = ref(false); // 定义加载状态

//是否显示导出按钮
const isShowExport = ref(true)

// 分页相关状态
const total = ref(0); // 总条数
const pageSize = ref(15); // 每页显示的条数
const currentPage = ref(1); // 当前页码

const searchForm = ref({});

// 处理查询事件
const handleQueryClick = (formData) => {

    if (!formData.date_start || !formData.date_end) {
        ElMessage.warning('请选择时间范围后再查询');
        return; // 阻止导出
    }
    currentPage.value = 1
    //查询历史统计列表
    historyList(formData)
    //查询看板数据
    historySummary(formData)
};

//历史统计列表
const historyList = async (formData) => {
    searchForm.value = formData;
    isloading.value = true;
    try {
        const response = await proxy.$api.statistic.historyList({
            ...formData,
            page: currentPage.value,
            pageSize: pageSize.value
        });
        orderList.value = response.data.data; // 更新 orderList
        total.value = response.data.pagination.total; // 更新总条数

    } catch (error) {
        ElMessage.error('订单列表获取失败,请稍后重试');
    } finally {
        isloading.value = false; // 结束加载
    }
}

const summaryData = ref(null); // 用于存储看板数据
const show_handling_fee = ref(0);
//历史统计列表-看板数据
const historySummary = async (formData) => {
    try {
        const response = await proxy.$api.statistic.historySummary({
            ...formData,
        });
        summaryData.value = response.data.data.data[0]; // 更新看板数据
        show_handling_fee.value = response.data.data.show_handling_fee;

        console.log(summaryData.value, show_handling_fee.value);

    } catch (error) {
        ElMessage.error('订单列表获取失败,请稍后重试');
    }
}


const searchRef = ref(null)

// 导出订单列表
const hanldeExportExcel = (formData, updateProgress) => {
    // 检测必填字段
    if (!formData.date_start || !formData.date_end) {
        ElMessage.warning('请选择时间范围后再导出');
        searchRef.value?.resetExportStatus()
        return;
    }

    // 生成文件名
    const filename = '历史统计报表' + newTimeFormat('', 'string');

    // 初始进度：0%
    updateProgress(0);

    // 调用导出接口（假设接口支持onDownloadProgress回调）
    proxy.$api.statistic.historyExport(formData, filename, {
        onDownloadProgress: (event) => {
            // 计算进度（已下载字节/总字节）
            if (event.lengthComputable) {
                const progress = Math.round((event.loaded / event.total) * 100);
                updateProgress(progress); // 实时更新进度
            }
        }
    })
        .then(() => {
            // 接口返回成功后强制进度到100%
            updateProgress(100);
            ElMessage({ message: '导出成功！', type: 'success' });
        })
        .catch((error) => {
            // 失败时重置进度
            searchRef.value?.resetExportStatus()

            ElMessage.error('导出失败，请稍后重试');
            console.error('导出失败:', error);
        });
};


//查询门店列表
const storeList = ref([]);
const fetchAllStoreList = async () => {
    const perPage = 15;
    let allStores = [];
    // 用于存储最终格式化后的门店列表
    let formattedStoreList = [];

    try {
        const firstPageResponse = await proxy.$api.storesList({ page: 1, perPage });

        if (firstPageResponse.success && firstPageResponse.data) {
            allStores = [...allStores, ...firstPageResponse.data];
            const totalPages = firstPageResponse.pagination.totalPages;

            if (totalPages > 1) {
                const pageRequests = [];
                for (let page = 2; page <= totalPages; page++) {
                    pageRequests.push(proxy.$api.storesList({ page, perPage }));
                }

                const remainingResponses = await Promise.all(pageRequests);
                remainingResponses.forEach(response => {
                    if (response.success && response.data) {
                        allStores = [...allStores, ...response.data];
                    }
                });
            }

            // 关键步骤：将原始门店数据格式化为 { value: name, label: name }
            formattedStoreList = allStores.map(store => ({
                value: store.id, // value 用门店的 name 字段
                label: store.name  // label 也用门店的 name 字段
            }));

            // 打印格式化后的数据，查看结果
            // console.log('格式化后的门店列表:', formattedStoreList);
            storeList.value = formattedStoreList; // 返回格式化后的数据，供下拉选择等场景使用

        } else {
            console.error('第1页数据请求失败:', firstPageResponse);
        }

    } catch (error) {
        console.error('获取所有门店数据失败:', error);
    }
};

//查询终端列表
const terminalList = ref([]);
// 查询终端列表（确保所有分页请求都带 store_id）
const fetchAllTerminalList = async (store_id) => {
    const perPage = 15;
    let allTerminals = [];

    try {
        // 1. 第1页请求：带 store_id
        const firstPageResponse = await proxy.$api.getTerminals({
            store_id, // 关键：传递门店ID
            page: 1,
            perPage
        });

        if (firstPageResponse.success && firstPageResponse.data) {
            allTerminals = [...allTerminals, ...firstPageResponse.data];
            const totalPages = firstPageResponse.pagination.totalPages;

            if (totalPages > 1) {
                const pageRequests = [];
                // 2. 第2页及以后请求：同样带 store_id
                for (let page = 2; page <= totalPages; page++) {
                    pageRequests.push(proxy.$api.getTerminals({
                        store_id, // 关键：分页请求也要传门店ID
                        page,
                        perPage
                    }));
                }

                const remainingResponses = await Promise.all(pageRequests);
                remainingResponses.forEach(response => {
                    if (response.success && response.data) {
                        allTerminals = [...allTerminals, ...response.data];
                    }
                });
            }

            // 格式化终端数据为下拉选项格式
            terminalList.value = allTerminals.map(terminal => ({
                value: terminal.id,
                label: terminal.name
            }));

        } else {
            console.error('终端列表第1页请求失败:', firstPageResponse);
            terminalList.value = []; // 请求失败也清空终端选项
        }

    } catch (error) {
        console.error('获取终端数据失败:', error);
        terminalList.value = []; // 异常时也清空终端选项
    }
};


// 定义门店选择变化的处理函数
const handleStoreChange = async (storeId) => {
    terminalList.value = []; // 清空终端下拉选项
    if (searchForm.value) {
        searchForm.value.device_id = ''; // 清空搜索表单中已选的终端值
    }

    // 只有选择了具体门店（storeId存在），才查询终端列表
    if (storeId) {
        // console.log('选择的门店ID：', storeId);
        // 调用终端列表查询函数（若接口需要门店ID，这里传入）
        await fetchAllTerminalList(storeId); // 传入门店ID
    } else {
        // 未选择门店时，清空终端列表
        terminalList.value = [];
    }
};


// 处理重置事件
const handleResetClick = (formData) => {
    console.log('接收到重置数据:', formData);
    total.value = 0; // 重置总条数
    currentPage.value = 1; // 重置当前页码
    handleQueryClick(formData);
};

// 处理页码变化
const handlePageChange = (page) => {
    currentPage.value = page;
    historyList(searchForm.value); // 重新查询数据
};

// 处理每页条数变化
const handleSizeChange = (size) => {
    pageSize.value = size;
    currentPage.value = 1; // 重置当前页码
    historyList(searchForm.value); // 重新查询数据
};



// 支付方式
const payTypeList = [
    { value: 1, label: "支付宝" },
    { value: 2, label: "微信" },
    { value: 3, label: "云闪付" }
];

// 合并后的配置对象
const searchOptions = ref({
    channelList: [],
    payTypeList,
    terminalList,
    storeList,
    handleStoreChange,
});


// 处理显示订单详情
const orderModal = ref(null); // 获取 page-modal 组件的引用
const handleShowDetail = (orderData) => {
    orderModal.value.openModal(orderData); // 调用 page-modal 的 openModal 方法
};


// 组件挂载时执行默认查询
onMounted(() => {
    // 默认查询参数
    const defaultSearchForm = {};
    for (const item of searchConfig(searchOptions.value).formItems) {
        defaultSearchForm[item.prop] = item.initialValue ?? '';
    }

    // 触发默认查询
    handleQueryClick(defaultSearchForm);
    fetchAllStoreList();
});
</script>

<style lang="less" scoped>
.history {
    .export-excel {
        display: flex;
        flex-direction: row;
        align-items: center;
        color: #18bc37;
        cursor: pointer;
        -webkit-user-select: none;
    }

    .export-excel:hover {
        color: #409eff;
    }

    .pagination {
        margin: 1.25rem 0;
        display: flex;
        justify-content: flex-end;
    }
}
</style>
